import useStore from '../../../../../Hooks/useStore';

const SingleProductTab = () => {
  const [getters, setters] = useStore();
  const {
    ticket: { getTicket },
  } = getters;
  const { pinnedProducts, selectedProducts } = getTicket('form.batch');

  return <>produto</>;
};

export default SingleProductTab;
